import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import './Homepage.css'; // Importa il file CSS
import { HashLink } from 'react-router-hash-link'; // Import HashLink

const HomePage = () => {
    const carouselStyles = {
        width: '30%', // Imposta la larghezza del carousel al 30% dello schermo
        margin: '0 auto', // Per centrare il carousel orizzontalmente
    };

    return (
        <div>
            <div style={{ position: 'relative' }}>
                {/* Immagine principale (keyboard.jpg) */}
                <img src="keyboard.jpg" width="100%" alt="Keyboard" />

                {/* Nuova immagine sovrapposta */}
                {/*<img*/}
                {/*    src="integration.jpg"*/}
                {/*    alt="Sovrapposta"*/}
                {/*    className="overlap-image"*/}
                {/*/>*/}

                <div className="overlap-image">
                    <Carousel showThumbs={false} infiniteLoop autoPlay showStatus={false} interval={10000}>
                        <div>
                            <img src="Frase_1.jpg" width={1000}/>
                            {/*<p className="legend">Descrizione Immagine 2</p>*/}
                        </div>
                        <div>
                            <img src="Frase_2.jpg" width={1000}/>
                            {/*<p className="legend">Descrizione Immagine 2</p>*/}
                        </div>
                        <div>
                            <img src="Frase_3.jpg" width={1000}/>
                            {/*<p className="legend">Descrizione Immagine 2</p>*/}
                        </div>
                        <div>
                            <img src="Frase_4.jpg" width={1000}/>
                            {/*<p className="legend">Descrizione Immagine 2</p>*/}
                        </div>
                        {/*<div>*/}
                        {/*    <img src="calculation.png" alt="Immagine 2" width={1000}/>*/}
                        {/*    /!*<p className="legend">Descrizione Immagine 2</p>*!/*/}
                        {/*</div>*/}
                        {/* Aggiungi altre immagini qui */}
                    </Carousel>
                </div>
            </div>

            <h2 className="legend">Servizi Offerti</h2>

            <div className="home-icon-container">
                <div className="home-icon-element">
                    <HashLink to="/servizi#servizio-1"><img src="icon/gestionale-icon.png" className="home-icon" alt="Gestionale" />
                    <br />
                    SOFTWARE GESTIONALE
                        {/*<img src="icon/arrow.png" className="home-arrow" />*/}
                    </HashLink>
                </div>
                <div className="home-icon-element">
                    <HashLink to="/servizi#servizio-2"><img src="icon/dashboard-icon.png" className="home-icon" alt="Data Analysis" />
                    <br />
                    DATA ANALYSIS
                        {/*<img src="icon/arrow.png" className="home-arrow" />*/}
                    </HashLink>
                </div>
                <div className="home-icon-element">
                    <HashLink to="/servizi#servizio-3"><img src="icon/data-integration-icon.png" className="home-icon" alt="Data Integration" />
                    <br />
                    DATA INTEGRATION
                        {/*<img src="icon/arrow.png" className="home-arrow" />*/}
                    </HashLink>
                </div>
            </div>

            <div className="home-icon-container">
                <div className="home-icon-element">
                    <HashLink to="/servizi#servizio-4"><img src="icon/booking.png" className="home-icon" alt="Prenotazioni" />
                    <br />
                    PRENOTAZIONI
                        {/*<img src="icon/arrow.png" className="home-arrow" />*/}
                    </HashLink>
                </div>
                <div className="home-icon-element">
                    <HashLink to="/servizi#servizio-5"><img src="icon/mobile-app-icon.png" className="home-icon" alt="Mobile App" />
                    <br />
                    APP MOBILE
                        {/*<img src="icon/arrow.png" className="home-arrow" />*/}
                    </HashLink>
                </div>
                <div className="home-icon-element">
                    <HashLink to="/servizi#servizio-6"><img src="icon/engine-icon-2.png" className="home-icon" alt="Motore Calcolo" />
                    <br />
                    MOTORI CALCOLO
                        {/*<img src="icon/arrow.png" className="home-arrow" />*/}
                    </HashLink>
                </div>
            </div>

            <div className="home-icon-container">
                <div className="home-icon-element">
                    <HashLink to="/servizi#servizio-7"><img src="icon/website-icon-1.png" className="home-icon" alt="Siti" />
                    <br />
                    SITI WEB
                        {/*<img src="icon/arrow.png" className="home-arrow" />*/}
                    </HashLink>
                </div>
            </div>

            {/*<p>Breve descrizione dell'azienda...</p>*/}
        </div>
    );
};

export default HomePage;
